import { useState, useCallback } from 'react';
import { ShopItem } from '../types';

const INITIAL_BUDGET = 200;

const SHOP_ITEMS: ShopItem[] = [
  { id: 1, name: 'Art Canvas Pack (5pcs)', price: 45.00, gst: true },
  { id: 2, name: 'Paint Set - Premium', price: 35.00, gst: true },
  { id: 3, name: 'Display Easel', price: 40.00, gst: true },
  { id: 4, name: 'Price Tags & Labels', price: 15.00, gst: false },
  { id: 5, name: 'Decorative Tablecloth', price: 25.00, gst: true },
  { id: 6, name: 'Art Portfolio Case', price: 30.00, gst: true },
  { id: 7, name: 'Business Cards (100)', price: 20.00, gst: true },
  { id: 8, name: 'Cash Box', price: 25.00, gst: false }
];

export const useMoneyGame = () => {
  const [budget] = useState(INITIAL_BUDGET);
  const [items] = useState(SHOP_ITEMS);
  const [cart, setCart] = useState<ShopItem[]>([]);
  const [score, setScore] = useState(0);
  const [gameOver, setGameOver] = useState(false);

  const calculateRemainingBudget = useCallback(() => {
    const totalSpent = cart.reduce((sum, item) => sum + item.price, 0);
    return budget - totalSpent;
  }, [cart, budget]);

  const addToCart = useCallback((item: ShopItem) => {
    if (item.price <= calculateRemainingBudget()) {
      setCart(prev => [...prev, item]);
      setScore(prev => prev + 5); // Points for each item added
    }
  }, [calculateRemainingBudget]);

  const removeFromCart = useCallback((item: ShopItem) => {
    setCart(prev => prev.filter(i => i.id !== item.id));
    setScore(prev => Math.max(0, prev - 5)); // Deduct points for removing items
  }, []);

  const finishShopping = useCallback(() => {
    const essentialItems = new Set([1, 2, 3, 4]); // Canvas, Paint, Easel, Price Tags
    const hasEssentials = essentialItems.size === cart
      .filter(item => essentialItems.has(item.id))
      .length;

    if (hasEssentials) {
      setScore(prev => prev + 50); // Bonus for getting all essential items
    }

    setGameOver(true);
  }, [cart]);

  return {
    budget,
    items,
    cart,
    remainingBudget: calculateRemainingBudget(),
    score,
    gameOver,
    addToCart,
    removeFromCart,
    finishShopping
  };
};